import {measureTime} from "../../util/debug";
import {Assets} from "pixi.js";

let weather_sheet;

// in new browsers await can be top level
async function load_textures() {
  weather_sheet = await Assets.load("/weather/textures/spritesheet.json");
  return Promise.all([weather_sheet]);
}

const measuredLoadTextures = measureTime(load_textures);


export { weather_sheet,  measuredLoadTextures as load_textures};


